<template>
  <div class="toolList">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>营销列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <span>名称:</span>
      <el-input v-model.trim="list.marketingName" placeholder="请输入优惠券名称"></el-input>
      <span>状态:</span>
      <el-select clearable @clear="onClear(2)" v-model="list.status" placeholder="请选择">
        <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
        <el-button type="primary" @click="getCouponList()">查找</el-button>
        <el-button type="primary" @click="$router.push(`/addTool/0`)">添加</el-button>
    </div>
    <el-table @selection-change="onSelectChange" :data="tableData" border style="width: 100%">
      <el-table-column align="center" type="selection" width="width"></el-table-column>
      <el-table-column align="center" prop="marketingId" label="影响工具id"></el-table-column>
      <el-table-column align="center" prop="marketingName" label="名称"></el-table-column>
      <el-table-column align="center" prop="isCoupon" label="是否和优惠券叠加"></el-table-column>
      <el-table-column align="center" prop="isUserDay" label="是否叠加会员权益"></el-table-column>
      <el-table-column align="center" prop="beginTime" label="开始时间"></el-table-column>
      <el-table-column align="center" prop="endTime" label="结束时间"></el-table-column>
      <el-table-column align="center" prop="strStatus" label="状态"></el-table-column>
      <el-table-column align="center" label="操作" width="350">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" v-if="row.status !=3" @click="onChangeStatus(row.marketingId)">失效</el-button>
          <el-button type="primary" size="mini" @click="$router.push(`/addTool/${row.marketingId}`)"
            v-if="$store.state.powerList.indexOf('coupon:info:list:edit') !== -1">编辑</el-button>
          <el-button type="primary" size="mini" @click="onDelRow(row.marketingId)"
            v-if="$store.state.powerList.indexOf('coupon:info:list:update') !== -1">删除</el-button>
            <el-button size="mini" type="primary" @click="$router.push(`/toolPrice/${row.marketingId}`)"
            v-if="$store.state.powerList.indexOf('scenery:ticket:list:price') !== -1">设置价格</el-button>
            <el-button size="mini" type="primary" @click="$router.push(`/toolLog/${row.marketingId}`)"
                  v-if="$store.state.powerList.indexOf('scenery:ticket:list:log') !== -1">查看日志</el-button>
          <!-- <el-button type="primary" size="mini" @click="goCouponQRCode(row.marketingId)">查看二维码</el-button> -->

          <!-- <template v-if="row.strReceiveWay != '定时发放'">
            <el-button type="primary" size="mini" @click="couponThrowPhone(row.marketingId)">手机号发放</el-button>
            <el-button type="primary" size="mini"
              @click="$router.push('/couponCodeList/' + row.marketingId)">查看券码</el-button>
          </template> -->

          <el-dialog title="优惠券二维码" :visible.sync="dialogVisible" width="30%" :before-close="handleClose"
            style="background: url()">
            <el-image style="width: 330px; height: 330px" :src="QRCode" :fit="fit">
            </el-image>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
          </el-dialog>
          <el-dialog title="手机号发放" :visible.sync="isInputPhone" width="30%" @close="handleClosePhone"
            style="background: url()">
            <el-tag closable :key="index" v-for="(tag, index) in dynamicTags" :disable-transitions="false"
              @close="handleCloseTag()">
              {{ tag }}
            </el-tag>
            <el-input class="input-new-tag" v-if="inputVisible" v-model="inputPhoneVal" maxlength="11" ref="saveTagInput"
              size="medium" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+点击输入手机号</el-button>
            <div style="color: red">
              tips:输入完一个手机号后按回车自动输入下一个手机号
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="isInputPhone = false">取 消</el-button>
              <el-button type="primary" @click="submitPhoneNum()">确 定</el-button>
            </span>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.currentPage"
      :page-sizes="[5, 10, 15, 20]" :page-size="list.pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total">
    </el-pagination>
  </div>
</template>
<script>
import {
  toolList,
  changeStatus,
  delTool,
  couponQRCode,
  couponAllCateAPI,
  couponThrowPhone,
} from "../../../api/tool";
export default {
  name: "toolList",
  data() {
    return {
      phoneArr: [],
      dynamicTags: [],
      inputPhoneVal: "",
      inputVisible: false,
      fit: "fill",
      tableData: [],
      pagination: {},
      ids: "",
      options1: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: " 进行中",
        },
        {
          value: 2,
          label: "未开始",
        },
        {
          value: 3,
          label: "已结束",
        },
        {
          value: 4,
          label: "已失效",
        }
      ],
      list: {
        currentPage: 1,
        pageSize: 5,
        marketingName: "",
        status: null,
      },
      marketingId: "",
      dialogVisible: false,
      QRCode: "",
      isInputPhone: false,
    };
  },
  created() {
    this.getCouponList();
    this.getCate();
  },
  methods: {
    submitPhoneNum() {
      this.requestPhoneNum();
    },
    couponThrowPhone(marketingId) {
      this.marketingId = marketingId;
      this.isInputPhone = true;
      // this.requestPhoneNum()
    },
    async requestPhoneNum(marketingId) {
      if (this.phoneArr.length <= 0) {
        this.$message({
          message: "请输入手机号",
          type: "warning",
        });
        return
      }
      let parmas = {
        marketingId: this.marketingId,
        phone: this.phoneArr.join(),
      };
      const { data } = await couponThrowPhone(parmas);
      this.$message({
        message: data.msg,
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    downLoadQRCode() {
      //  var url = this.QRCode;
      //  var aLink = document.createElement("a");
      //  aLink.style.display = "none";
      //  aLink.href = url;
      //  aLink.setAttribute("download", '优惠券二维码');
      //  document.body.appendChild(aLink);
      //  aLink.click();
      //  document.body.removeChild(aLink); //下载完成移除元素
    },
    async goCouponQRCode(marketingId) {
      this.dialogVisible = true;
      const { data } = await couponQRCode({
        marketingId: marketingId,
      });
      if (data.code == 0) {
        console.log(data.msg);
        this.QRCode = data.msg;
        console.log("图片", this.QRCode);
      }
    },
    async getCouponList() {
      const { data } = await toolList(this.list);
      this.tableData = data.list;
      this.pagination = data.pagination;
    },
    onChangeStatus(id) {
      this.$confirm("是否要设置这条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await changeStatus({
            marketingId: id,
          });
          if (data.code == 0) {
            this.$message({
              type: "success",
              message: data.msg,
            });
            this.getCouponList();
          } else {
            this.$message({
              type: "error",
              message: data.msg,
            });
          }
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
    onDelRow(id) {
      this.$confirm("是否要设置这条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data } = await delTool({
            marketingId: id ,
          });
          if (data.code == 0) {
            this.$message({
              type: "success",
              message: data.msg,
            });
            this.getCouponList();
          } else {
            this.$message({
              type: "error",
              message: data.msg,
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    onSelectChange(selection) {
      var arr = [];
      selection.map((item) => {
        arr.push(item.marketingId);
      });
      this.ids = arr.join(",");
    },
    async onChangeAll(status) {
      this.$confirm("是否要批量设置这些数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          if (this.ids == "") {
            return this.$message({
              type: "error",
              message: "请选择要设置的数据",
            });
          }

          const { data } = await changeStatus({
            ids: this.ids,
            status,
          });
          if (data.code == 0) {
            this.$message({
              type: "success",
              message: data.msg,
            });
            this.getCouponList();
          } else {
            this.$message({
              type: "error",
              message: data.msg,
            });
          }
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
    onClear(v) {
      if (v == 1) {
      } else if (v == 2) {
        this.list.status = null;
      }
    },
    handleSizeChange(num) {
      this.list.pageSize = num;
      this.getCouponList();
    },
    handleCurrentChange(num) {
      this.list.currentPage = num;
      this.getCouponList();
    },
    handleCloseTag(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleClosePhone() {
      this.dynamicTags = []
      this.phoneArr = []
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let reg = /^1\d/;
      if (!reg.test(this.inputPhoneVal) || this.inputPhoneVal.length !== 11) {
        return this.$message("请输入正确的手机号");
      }
      let inputValue = this.inputPhoneVal;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
      this.inputVisible = true;
      this.phoneArr.push(this.inputPhoneVal);

      this.inputPhoneVal = "";
      console.log(this.phoneArr.join());
      //  this.$nextTick((_) => {
      //   this.$refs.saveTagInput.$refs.input.focus();
      // });
    },
  },
};
</script>
<style lang="less" scoped>
.toolList {
  .el-tag+.el-tag {
    margin-left: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .el-breadcrumb {
    height: 35px;
    border-bottom: 1px solid rgb(192, 191, 191);
  }

  .el-table {
    margin-top: 50px;
  }

  .el-pagination {
    margin-top: 50px;
    float: right;
  }

  .search {
    margin-top: 50px;

    .el-input {
      width: 200px;
    }

    span {
      margin: 0 20px 0 40px;
    }

    .el-button {
      margin-left: 20px;
    }
  }

  .btn {
    margin-top: 50px;
    float: left;
  }
}
</style>
